// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"501d01ca","732":"948a7c77","780":"a27579da","977":"15911a10"}[chunkId] + ".chunk.js";
};